import React, { useEffect, useState } from "react";

import styled from "@emotion/styled";
import { Checkbox, Divider, Input, LoadingOverlay } from "@mantine/core";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { colors } from "../../configs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  createUserWithEmailAndPassword,
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import Cookies from "js-cookie";
import { db } from "../../firebase-config";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import useFirebaseAuth from "../../context/useFirebaseAuth";

const InputsBox = styled(Box)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width: "100%",
  gap: 5,
});
const InputContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: "5px 5px",
  width: "100%",
});
const InputLabel = styled(Typography)({
  marginBottom: "3px",
});
const RegisterForm = () => {
  const { authUser, loggedUser } = useFirebaseAuth();
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const [name, setName] = useState<string>("");
  const [firstname, setFirstname] = useState<string>("");

  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const [errorMsg, setErrorMsg] = useState<string>("");
  const [successMsg, setSuccessMsg] = useState<string>("");
  const [checkCGU, setCheckCGU] = useState(false);

  useEffect(() => {
    console.log("====================================");
    console.warn("AUTH USER: ", authUser);
    console.log("====================================");
    console.log("====================================");
    console.warn("LOGGEDIN USER: ", loggedUser);
    console.log("====================================");
  }, [authUser]);

  const register = () => {
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");
    console.log("====================================");
    console.log("REGISTRATION DATA: ", name);

    console.log("====================================");
    createUserWithEmailAndPassword(getAuth(), email, password)
      .then(async (user) => {
        console.log("====================================");
        console.log("USER REGISTERED SUCCESS: ", user);
        console.log("====================================");
        try {
          await setDoc(doc(db, "users", user.user.uid), {
            uid: user.user.uid,
            email: email,
            origin: "Teksa Travel",
            lastLogin: new Date().getTime(),
            password: password,
            firstname: firstname,
            name: name,
          });

          Cookies.set("auth_token", user.user.uid);
          setSuccessMsg(
            "Bravo, Inscription réussie, Un mail de validation vous a été envoyé."
          );
          setLoading(false);
          window.location.reload();
        } catch (e: any) {
          setLoading(false);
          setErrorMsg(
            "Erreur inconnue: Impossible de créer votre profile, veuillez nous contacter."
          );
        }
      })
      .catch((regError) => {
        switch (regError.code) {
          case "auth/email-already-in-use":
            setErrorMsg(
              'Cette adresse e-mail dispose déjà d\'un compte. Si vous avez oublié votre mot de passe cliquez sur "Mot de passe oublié " en haut.'
            );
            break;
          case "auth/invalid-email":
            setErrorMsg("Adresse e-mail invalide");
            break;
          case "auth/weak-password":
            setErrorMsg(
              "Mot de passe trop faible, minimum 6 caractères requis."
            );
            break;
          default:
            setErrorMsg(
              "Erreur inconue, réessayez ou contactez l'administrateur"
            );
            break;
        }
        setLoading(false);

        console.warn("USER REGISTERED ERROR: ", regError);
      });
  };

  const registerWithGoogle = () => {
    setErrorMsg("");
    setSuccessMsg("");
    const auth = getAuth();
    auth.languageCode = "en";
    const provider = new GoogleAuthProvider();

    signInWithPopup(auth, provider)
      .then(async (result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential?.accessToken;
        // The signed-in user info.
        const user = result.user;
        // IdP data available using getAdditionalUserInfo(result)
        // ...
        Cookies.set("auth_token", user.uid);

        console.warn("USER REGISTERED ERROR: ", user);

        try {
          await setDoc(doc(db, "users", user.uid), {
            uid: user.uid,
            email: email,
            origin: "Teksa Travel",
            lastLogin: new Date().getTime(),
            //  password: password,
            //  firstname: firstname,
            //  name: name,
          });

          Cookies.set("auth_token", user.uid);
          setSuccessMsg(
            "Bravo, Inscription réussie, vous allez être redirigé..."
          );
          setLoading(false);
          window.location.reload();
        } catch (e: any) {
          setLoading(false);
          setErrorMsg(
            "Erreur inconnue: Impossible de créer votre profile, veuillez nous contacter."
          );
        }
      })
      .catch((error) => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.customData.email;
        // The AuthCredential type that was used.
        const credential = GoogleAuthProvider.credentialFromError(error);
        // ...
      });
  };
  return (
    <div>
      {loading ? (
        <LoadingOverlay visible={loading} overlayBlur={2} />
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",

              padding: "10px 50px",
            }}>
            <Typography
              variant="h3"
              component="code"
              sx={{
                textAlign: "center",
                margin: "0 0 25px 0",
                fontWeight: "bold",
              }}>
              Let's go
            </Typography>
            <Button
              onClick={() => registerWithGoogle()}
              variant="contained"
              color="primary"
              sx={{
                padding: "7px",
                color: "#FFFFFF",
                borderRadius: "10px",
              }}>
              <GoogleIcon
                sx={{
                  marginRight: "3px",
                }}
              />
              SignUp with
            </Button>
            <Divider my="sm" label="Or continue with" labelPosition="center" />
          </Box>
          <InputsBox>
            <InputContainer>
              <InputLabel variant="body1">First name</InputLabel>
              <Input
                variant="unstyled"
                id="firstname"
                placeholder="First name"
                size="xs"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  backgroundColor: "#E7ECF3",
                  borderRadius: "10px",
                  padding: "7px",
                }}
                value={firstname}
                onChange={(evt: any) => setFirstname(evt.target.value)}
              />
            </InputContainer>
            <InputContainer>
              <InputLabel variant="body1">Last name</InputLabel>
              <Input
                variant="unstyled"
                id="lastname"
                placeholder="Last name"
                size="xs"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  backgroundColor: "#E7ECF3",
                  borderRadius: "10px",
                  padding: "7px",
                }}
                value={name}
                onChange={(evt: any) => setName(evt.target.value)}
              />
            </InputContainer>
          </InputsBox>
          <InputsBox>
            <InputContainer>
              <InputLabel variant="body1">Email</InputLabel>
              <Input
                variant="unstyled"
                id="email"
                placeholder="Enter your email"
                size="xs"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  backgroundColor: "#E7ECF3",
                  borderRadius: "10px",
                  padding: "7px",
                }}
                value={email}
                onChange={(evt: any) => setEmail(evt.target.value)}
              />
            </InputContainer>
          </InputsBox>
          <InputsBox>
            <InputContainer>
              <InputLabel variant="body1">Password</InputLabel>

              <Input
                variant="unstyled"
                id="password"
                placeholder="Enter your password"
                size="xs"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  backgroundColor: "#E7ECF3",
                  borderRadius: "10px",
                  padding: "7px",
                }}
                type={showPassword ? "text" : "password"}
                rightSection={
                  !showPassword ? (
                    <VisibilityIcon
                      sx={{ color: "GrayText" }}
                      onClick={() => setShowPassword(true)}
                    />
                  ) : (
                    <VisibilityOffIcon
                      sx={{ color: "GrayText" }}
                      onClick={() => setShowPassword(false)}
                    />
                  )
                }
                value={password}
                onChange={(evt: any) => setPassword(evt.target.value)}
              />
            </InputContainer>
          </InputsBox>
          <InputsBox>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
              }}>
              <Checkbox
                checked={checkCGU}
                onChange={() => setCheckCGU(!checkCGU)}
              />

              <span
                style={{
                  fontSize: "11px",
                  margin: "3px",
                  fontWeight: "light",
                  color: "GrayText",
                  marginLeft: "5px",
                }}>
                I’ve read and accepted
                <span
                  style={{
                    color: colors.main,
                    margin: "3px",
                  }}>
                  Terms of Service
                </span>
                and
                <span
                  style={{
                    color: colors.main,
                    margin: "3px",
                  }}>
                  Privacy Policy
                </span>
              </span>
            </Box>
          </InputsBox>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              margin: "20px 0",
            }}>
            {errorMsg && (
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "100",
                  margin: "2px",
                  color: "red",
                }}>
                {errorMsg}
              </span>
            )}
            {successMsg && (
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: "100",
                  margin: "2px 0",
                  color: "green",
                }}>
                {successMsg}
              </span>
            )}
            <Button
              disabled={!checkCGU}
              onClick={() => register()}
              variant="contained"
              color="primary"
              sx={{
                padding: "7px",
                color: "#FFFFFF",
                borderRadius: "10px",
                width: "100%",
              }}>
              Singin Up
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "5px",
            }}>
            <span
              style={{
                fontSize: "11px",
                margin: "3px",
                fontWeight: "light",
                color: "GrayText",
                marginLeft: "5px",
              }}>
              Alheady have an account?
              <span
                style={{
                  color: colors.main,
                  margin: "3px",
                }}>
                Sign in
              </span>
            </span>
          </Box>
        </>
      )}
    </div>
  );
};

export default RegisterForm;
